/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const DeviceDesktopXXL24Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 24, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="DeviceDesktopXXL24Icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 4C3.44772 4 3 4.44772 3 5V14C3 14.5523 3.44772 15 4 15H9V18H6.5V19H18.5V18H16V15H21C21.5523 15 22 14.5523 22 14V5C22 4.44771 21.5523 4 21 4H4ZM15 15H13V18H15V15ZM12 15H10V18H12V15ZM4 5L21 5V14H4V5Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

DeviceDesktopXXL24Icon.tags = [
  'computer',
  'monitor',
  'desktop',
  'screen',
  'display',
];

DeviceDesktopXXL24Icon.category = '24x24';

DeviceDesktopXXL24Icon.iconSize = 24;
